/**
 * Utility functions for FarmDetailsModal.
 * Extracted from FarmDetailsModal.tsx.
 */

/**
 * Helper to check if endDate is previous year (local time)
 */
export function isEndDatePreviousYear(
  endDate: string | null | undefined,
): boolean {
  if (!endDate) return false;
  const end = new Date(endDate);
  const now = new Date();
  return end.getFullYear() === now.getFullYear() - 1;
}

/**
 * Helper function to construct full name from user object
 */
export function getFullName(user: any): string {
  if (!user) return "N/A";

  const parts = [user.name, user.middleName, user.lastName].filter(
    (part) => part && part.trim(),
  );
  return parts.length > 0 ? parts.join(" ") : "N/A";
}
